import React, { useEffect, useRef } from 'react';

const BackgroundEffects = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationId;

    // Set canvas size
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Particles array
    const particles = [];
    const meteors = [];

    // Create particles
    const createParticles = () => {
      for (let i = 0; i < 50; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          size: Math.random() * 3 + 1,
          speedX: (Math.random() - 0.5) * 0.5,
          speedY: (Math.random() - 0.5) * 0.5,
          opacity: Math.random() * 0.5 + 0.2,
          color: `hsl(${Math.random() * 60 + 300}, 100%, 70%)` // Purple to pink hues
        });
      }
    };

    // Create meteors
    const createMeteor = () => {
      meteors.push({
        x: Math.random() * canvas.width + canvas.width,
        y: Math.random() * canvas.height / 2,
        speedX: -8 - Math.random() * 4,
        speedY: 2 + Math.random() * 2,
        size: Math.random() * 2 + 1,
        opacity: 1,
        tail: []
      });
    };

    // Initialize
    createParticles();

    // Animation loop
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw particles
      particles.forEach((particle, index) => {
        // Update position
        particle.x += particle.speedX;
        particle.y += particle.speedY;

        // Wrap around screen
        if (particle.x < 0) particle.x = canvas.width;
        if (particle.x > canvas.width) particle.x = 0;
        if (particle.y < 0) particle.y = canvas.height;
        if (particle.y > canvas.height) particle.y = 0;

        // Draw particle
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fillStyle = particle.color;
        ctx.globalAlpha = particle.opacity;
        ctx.fill();

        // Add glow effect
        ctx.shadowBlur = 20;
        ctx.shadowColor = particle.color;
        ctx.fill();
        ctx.shadowBlur = 0;
      });

      // Draw meteors
      meteors.forEach((meteor, index) => {
        // Update position
        meteor.x += meteor.speedX;
        meteor.y += meteor.speedY;
        meteor.opacity -= 0.005;

        // Add to tail
        meteor.tail.push({ x: meteor.x, y: meteor.y, opacity: meteor.opacity });
        if (meteor.tail.length > 20) {
          meteor.tail.shift();
        }

        // Draw meteor tail
        meteor.tail.forEach((point, i) => {
          const alpha = (point.opacity * i) / meteor.tail.length;
          ctx.globalAlpha = alpha;
          ctx.beginPath();
          ctx.arc(point.x, point.y, meteor.size * (i / meteor.tail.length), 0, Math.PI * 2);
          ctx.fillStyle = '#ffffff';
          ctx.fill();
        });

        // Draw meteor head
        ctx.globalAlpha = meteor.opacity;
        ctx.beginPath();
        ctx.arc(meteor.x, meteor.y, meteor.size, 0, Math.PI * 2);
        ctx.fillStyle = '#ffffff';
        ctx.shadowBlur = 15;
        ctx.shadowColor = '#ffffff';
        ctx.fill();
        ctx.shadowBlur = 0;

        // Remove meteor if off screen or faded
        if (meteor.x < -100 || meteor.opacity <= 0) {
          meteors.splice(index, 1);
        }
      });

      ctx.globalAlpha = 1;

      // Create new meteors randomly
      if (Math.random() < 0.003) {
        createMeteor();
      }

      animationId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="bg-canvas"
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        pointerEvents: 'none'
      }}
    />
  );
};

export default BackgroundEffects;